module.exports = __webpack_public_path__ + "static/img/768.3eac586.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/768.png
// module id = 3tnG
// module chunks = 1